import { render, staticRenderFns } from "./Monitoring.vue?vue&type=template&id=270b78b3&scoped=true"
import script from "./Monitoring.vue?vue&type=script&lang=js"
export * from "./Monitoring.vue?vue&type=script&lang=js"
import style0 from "./Monitoring.vue?vue&type=style&index=0&id=270b78b3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270b78b3",
  null
  
)

export default component.exports